var map = {
	"./academicachiever.png": [
		40583,
		583
	],
	"./alien.png": [
		40549,
		549
	],
	"./apple.png": [
		38141,
		8141
	],
	"./aroundtheworld.png": [
		59109,
		9109
	],
	"./avocado2022.png": [
		97924,
		7924
	],
	"./avocado2023.png": [
		24317,
		4317
	],
	"./banana.png": [
		65744,
		5744
	],
	"./baseball.png": [
		36084,
		6084
	],
	"./basketball.png": [
		30643,
		643
	],
	"./beaker.png": [
		59980,
		9980
	],
	"./boat.png": [
		84298,
		4298
	],
	"./book.png": [
		62591,
		2591
	],
	"./camera.png": [
		134,
		134
	],
	"./campfirering2023.png": [
		42472,
		2472
	],
	"./cat.png": [
		18305,
		8305
	],
	"./chavocado2023.png": [
		43765,
		3765
	],
	"./cheese2022.png": [
		46026,
		5547
	],
	"./cheese2023.png": [
		85171,
		5171
	],
	"./cloud.png": [
		906,
		906
	],
	"./colorfulcreative.png": [
		9701,
		9701
	],
	"./communitychampion.png": [
		71026,
		1026
	],
	"./confidencebuilder.png": [
		8999,
		8999
	],
	"./coolcamper.png": [
		33920,
		3920
	],
	"./dino.png": [
		13242,
		742
	],
	"./dog.png": [
		40551,
		551
	],
	"./donut.png": [
		17708,
		7708
	],
	"./face1.png": [
		79809,
		9809
	],
	"./face10.png": [
		94715,
		4715
	],
	"./face12.png": [
		22493,
		2493
	],
	"./face13.png": [
		57132,
		7132
	],
	"./face14.png": [
		96408,
		6408
	],
	"./face15.png": [
		12450,
		2450
	],
	"./face2.png": [
		6053,
		6053
	],
	"./face3.png": [
		78396,
		8396
	],
	"./face4.png": [
		53704,
		3704
	],
	"./face5.png": [
		59834,
		9834
	],
	"./face6.png": [
		47768,
		7768
	],
	"./face7.png": [
		6858,
		6858
	],
	"./face8.png": [
		43534,
		3534
	],
	"./face9.png": [
		81901,
		1901
	],
	"./fish.png": [
		70998,
		998
	],
	"./flower.png": [
		39666,
		9666
	],
	"./gameconcontroller.png": [
		67645,
		7645
	],
	"./gameconshield.png": [
		11575,
		1575
	],
	"./goco2022.png": [
		70423,
		423
	],
	"./gocowelcome2023.png": [
		3590,
		3590
	],
	"./hat.png": [
		19628,
		9628
	],
	"./hummingbird.png": [
		38546,
		8546
	],
	"./koala.png": [
		25248,
		5248
	],
	"./makers.png": [
		5123,
		5123
	],
	"./moneymakersmonth.png": [
		58848,
		8848
	],
	"./mug.png": [
		5447,
		5447
	],
	"./outschooltalentmonth.png": [
		67821,
		7821
	],
	"./owl.png": [
		11282,
		1282
	],
	"./planet.png": [
		29433,
		9433
	],
	"./rubix.png": [
		59983,
		9983
	],
	"./star.png": [
		85120,
		5120
	],
	"./steammonth2023.png": [
		4751,
		4751
	],
	"./studyninja.png": [
		3221,
		3221
	],
	"./sun.png": [
		28268,
		8268
	],
	"./superstar.png": [
		3430,
		3430
	],
	"./unicorn.png": [
		69475,
		9475
	],
	"./worldartandliteraturemonth.png": [
		93978,
		3978
	],
	"./worldbuilder.png": [
		80144,
		144
	],
	"./writersmonth.png": [
		33784,
		3784
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 46951;
module.exports = webpackAsyncContext;